.customerPanel {
    flex-grow: 1;
    flex-direction: column;
    width: 100%;
    background-color: var(--mantine-color-dark-7);
    position: relative;
    scrollbar-color: var(--mantine-color-gray-7) var(--mantine-color-dark-5);
}

.responsivePanel {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-color: var(--mantine-color-gray-7) var(--mantine-color-dark-5);
}

.topSection {
    flex-direction: column;
    margin: 12px;
    margin-bottom: 0;
}
